import urlcat from "urlcat";

import { axiosInstance, parseResponse, TENANT_API_URL } from "..";

const CHAT_URL = `${TENANT_API_URL}/chat`;

export const getUserChat = async (data: any) => {
  try {
    const response = await axiosInstance.post(`${CHAT_URL}`, data);
    const result = parseResponse(response);
    // The history endpoint persists incoming read status before returning.
    // The socket event only broadcasts receipts and has no persistence ack.
    if (result?.success && typeof window !== "undefined")
      window.dispatchEvent(
        new CustomEvent("wisterias:messages-read", {
          detail: { scope: "staff" },
        })
      );
    return result;
  } catch (error: any) {
    return parseResponse(error.response);
  }
};

export const getMembers = async (id: string, queryParams: any) => {
  try {
    if (!id || !/^[a-zA-Z0-9_-]+$/.test(id)) {
      throw new Error("Invalid ID");
    }
    const url = urlcat(`${CHAT_URL}/${id}`, queryParams);
    const response = await axiosInstance.get(url);
    return parseResponse(response);
  } catch (error: any) {
    return parseResponse(error.response);
  }
};

export const updateReadStatus = async (data: any) => {
  try {
    const response = await axiosInstance.put(`${CHAT_URL}`, data);
    const result = parseResponse(response);
    if (result?.success && typeof window !== "undefined")
      window.dispatchEvent(
        new CustomEvent("wisterias:messages-read", {
          detail: { scope: "staff" },
        })
      );
    return result;
  } catch (error: any) {
    return parseResponse(error.response);
  }
};

export const deleteMessage = async (data: any) => {
  try {
    const response = await axiosInstance.post(`${CHAT_URL}/delete`, data);
    return parseResponse(response);
  } catch (error: any) {
    return parseResponse(error.response);
  }
};
